import { render, staticRenderFns } from "./cadastro.vue?vue&type=template&id=6e9feaa0&scoped=true"
import script from "./cadastro.vue?vue&type=script&lang=js"
export * from "./cadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9feaa0",
  null
  
)

export default component.exports